import { normaliseSVGpoint } from '../utils';
import theme from '../popover.theme';

const triangleWidth = parseInt(theme.triangleWidth, 10);
const triangleHeight = parseInt(theme.triangleHeight, 10);

const strokes = {
  normal: theme.arrowBorderColor,
  secondary: theme.borderColor,
  tertiary: theme.arrowBorderColor,
  warning: theme.borderColorWarning,
  alert: theme.borderColorAlert,
};

const fills = {
  normal: theme.backgroundColor,
  secondary: theme.secondaryBackgroundColor,
  tertiary: theme.tertiaryBackgroundColor,
  warning: theme.borderColorWarning,
  alert: theme.borderColorAlert,
};

const getPositionModifier = (orientation, position) => {
  const minSide =
    orientation === 'bottom' || orientation === 'top' ? 'left' : 'top';
  const maxSide =
    orientation === 'bottom' || orientation === 'top' ? 'right' : 'bottom';
  if (position > 50) {
    return {
      [maxSide]: `${100 - position}%`,
    };
  }
  return {
    [minSide]: `${position}%`,
  };
};

const getOffsetModifier = (orientation, bottomEdge, position) => {
  const translateModifier =
    position === 50 ? position : 50 / Math.abs(position - 50);
  if (orientation === 'top') {
    return {
      transform: `translate(-${translateModifier}%, 0)`,
      top: `${bottomEdge + 1}px`,
    };
  }
  if (orientation === 'bottom') {
    return {
      transform: `translate(-${translateModifier}%, 0)`,
      top: '0px',
    };
  }
  if (orientation === 'left') {
    return {
      transform: `translate(0, -${translateModifier}%)`,
      right: '1px',
    };
  }
  if (orientation === 'right') {
    return {
      transform: `translate(0, -${translateModifier}%)`,
      left: '1px',
    };
  }
  return {};
};

export const arrowPoints = {
  right: [
    normaliseSVGpoint(triangleHeight),
    0,
    0,
    normaliseSVGpoint(triangleWidth / 2),
    normaliseSVGpoint(triangleHeight),
    normaliseSVGpoint(triangleWidth),
  ],
  left: [
    0,
    0,
    normaliseSVGpoint(triangleHeight),
    normaliseSVGpoint(triangleWidth / 2),
    0,
    normaliseSVGpoint(triangleWidth),
  ],
  bottom: [
    0,
    normaliseSVGpoint(triangleHeight),
    normaliseSVGpoint(triangleWidth / 2),
    0,
    normaliseSVGpoint(triangleWidth),
    normaliseSVGpoint(triangleHeight),
  ],
  top: [
    0,
    0,
    normaliseSVGpoint(triangleWidth / 2),
    normaliseSVGpoint(triangleHeight),
    normaliseSVGpoint(triangleWidth),
    0,
  ],
};

export const calculateInlineStyle = (orientation, position, bottomEdge) => ({
  position: 'absolute',
  zIndex: 1,
  overflow: 'hidden',
  [orientation === 'top' || orientation === 'bottom' ? 'width' : 'height']: `${
    theme.triangleWidth
  }`,
  [orientation === 'top' || orientation === 'bottom' ? 'height' : 'width']: `${
    theme.triangleHeight
  }`,
  ...getOffsetModifier(orientation, bottomEdge, position),
  ...getPositionModifier(orientation, position),
});

export const getFillColor = (inverse, themeType, arrowColor) =>
  inverse && themeType !== 'alert' ? arrowColor : fills[themeType];
  // inverse && themeType !== 'alert' ? theme.inverseBackground : fills[themeType];

export const getStrokeColor = (inverse, themeType, arrowColor) =>
  inverse && themeType !== 'alert' ? arrowColor : strokes[themeType];
  // inverse && themeType !== 'alert' ? theme.borderColor : strokes[themeType];
